import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    show: false,
    type: null, // 'required' or 'warning'
    message: '',
    daysSinceLastChange: 0,
    policyDays: 0,
    daysUntilExpiry: 0,
    urgency: 'warning', // 'warning' or 'critical'
    lastPasswordChange: null,
};

const passwordResetSlice = createSlice({
    name: 'passwordReset',
    initialState,
    reducers: {
        showPasswordResetModal: (state, action) => {
            const { 
                type, 
                message, 
                daysSinceLastChange, 
                policyDays, 
                daysUntilExpiry,
                urgency,
                lastPasswordChange 
            } = action.payload;
            
            return {
                ...state,
                show: true,
                type,
                message,
                daysSinceLastChange: daysSinceLastChange || 0,
                policyDays: policyDays || 0,
                daysUntilExpiry: daysUntilExpiry || 0,
                urgency: urgency || 'warning',
                lastPasswordChange: lastPasswordChange || null,
            };
        },
        closePasswordResetModal: (state) => {
            return {
                ...state,
                show: false,
                type: null,
                message: '',
                daysSinceLastChange: 0,
                policyDays: 0,
                daysUntilExpiry: 0,
                urgency: 'warning',
                lastPasswordChange: null,
            };
        },
        resetPassword: (state, action) => {
            // This action can be used to transition from warning to required
            const { type } = action.payload;
            return {
                ...state,
                type: type || 'required',
            };
        },
        setPasswordPolicy: (state, action) => {
            const { 
                daysSinceLastChange, 
                policyDays, 
                urgency,
                lastPasswordChange 
            } = action.payload;
            
            // Calculate days until expiry
            const daysUntilExpiry = Math.max(0, policyDays - daysSinceLastChange);
            
            return {
                ...state,
                daysSinceLastChange: daysSinceLastChange || 0,
                policyDays: policyDays || 0,
                daysUntilExpiry,
                urgency: urgency || 'warning',
                lastPasswordChange: lastPasswordChange || null,
            };
        },
    },
});

export const { 
    showPasswordResetModal, 
    closePasswordResetModal, 
    resetPassword,
    setPasswordPolicy 
} = passwordResetSlice.actions;

export default passwordResetSlice.reducer;
